var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Home Icon",
    d: "M0 22.2426V40C0 41.6569 1.34315 43 3 43H11.9986C13.8388 43 15.2453 41.3584 14.9631 39.54L13.0862 27.4444C12.5934 24.2684 16.764 22.646 18.5469 25.3203L19.5038 26.7558C20.6913 28.537 23.3087 28.537 24.4962 26.7558L25.1399 25.7902C26.9381 23.0928 31.1432 24.7693 30.5924 27.964L28.6051 39.4903C28.289 41.3238 29.7009 43 31.5615 43H41C42.6569 43 44 41.6569 44 40V22.2426C44 21.447 43.6839 20.6839 43.1213 20.1213L24.1213 1.12132C22.9497 -0.0502526 21.0503 -0.0502505 19.8787 1.12132L0.87868 20.1213C0.316071 20.6839 0 21.447 0 22.2426Z",
    fill: "#318CE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.229cad9709f914d4739ac0291756b457.svg";
export { ForwardRef as ReactComponent };